export const vegetables = [
  { "title": "broccoli" },
  { "title": "carrots" },
  { "title": "corn" },
  { "title": "kale" },
  { "title": "peapods" },
  { "title": "red bell pepper" },
]
